import React from "react";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { Translate } from "react-redux-i18n";

function TransactionItem({ item, variant }) {
  const Icon = variant === "accepted" ? FaCheckCircle : FaTimesCircle;

  return (
    <article className={`transaction-comment-card transaction-comment-card--${variant}`}>
      <div className="transaction-comment-card__icon" aria-hidden="true">
        <Icon />
      </div>
      <div className="transaction-comment-card__body">
        <p className="transaction-comment-card__text">{item.Comment}</p>
        {item.CreatedAt && (
          <time className="transaction-comment-card__date" dateTime={item.CreatedAt}>
            {item.CreatedAt}
          </time>
        )}
      </div>
    </article>
  );
}

class TransactionComments extends React.Component {
  render() {
    const { commentList = [], variant = "accepted" } = this.props;

    if (!commentList.length) {
      return (
        <div className="transaction-comments-empty">
          <p className="transaction-comments-empty__title">
            <Translate value="transaction_comments_empty_title" />
          </p>
          <p className="transaction-comments-empty__text">
            <Translate
              value={
                variant === "accepted"
                  ? "transaction_comments_empty_accepted"
                  : "transaction_comments_empty_rejected"
              }
            />
          </p>
        </div>
      );
    }

    return (
      <div className="transaction-comments-list">
        {commentList.map((item) => (
          <TransactionItem item={item} variant={variant} key={item.Id} />
        ))}
      </div>
    );
  }
}

export default TransactionComments;
